import {Link} from 'react-router-dom'
function Header(props) {
    return(
        <div class="center">
            <img id="banner" src="https://bradleymather.com/wp-content/uploads/2022/07/Bradley-R-Mather-5.png" alt="banner"/>
        <nav>
        <Link class="navlink" to='/'>
            <h3>Home</h3>
        </Link>
        <Link class="navlink" to='/about'>
            <h3>About</h3>
        </Link>
        <Link class="navlink" to='/projects'>
            <h3>Projects</h3>
        </Link>
        <a  class="navlink" href='mailto:bradley@bradleymather.com'>
            <h3>Contact Me</h3>
        </a>
        </nav>
        </div>
        )
}
export default Header